import { LoadingButton } from '@mui/lab'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from '@mui/material'
import { ExplanationAccordion } from 'components'
import { VehicleExporterNoteDto, VehicleExporterNoteValidationSchema } from 'dtos'
import { Formik } from 'formik'

interface ExporterNoteAddEditDialogProps {
  initialValues: VehicleExporterNoteDto
  open: boolean
  onClose: () => void
  onSave: (values: VehicleExporterNoteDto) => void
  isLoading: boolean
}

export default function ExporterNoteAddEditDialog({
  open,
  onClose,
  onSave,
  isLoading,
  initialValues
}: ExporterNoteAddEditDialogProps) {
  return (
    <Dialog open={open}>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validateOnChange
        validateOnBlur
        validationSchema={VehicleExporterNoteValidationSchema}
        onSubmit={(values, formikHelpers) => {
          onSave(values)
          formikHelpers.setSubmitting(false)
        }}
      >
        {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, setFieldValue, touched, values }) => {
          return (
            <form onSubmit={handleSubmit}>
              <DialogContent>
                <Grid container spacing={2} alignItems='center'>
                  <DialogTitle>Add Exporter Note</DialogTitle>

                  <Grid item xs={12}>
                    <TextField
                      disabled={isLoading || isSubmitting}
                      error={Boolean(touched.note && errors.note)}
                      helperText={touched.note && touched.note}
                      label='Exporter Note'
                      maxRows={4}
                      minRows={4}
                      multiline
                      name='note'
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.note}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12} sx={{ mt: 2 }}>
                  <ExplanationAccordion variant='outlined'>
                    When notes are saved, the date and time the note was created along with the name of the user who created the
                    note, and their company are automatically saved with the note.
                  </ExplanationAccordion>
                </Grid>
              </DialogContent>

              <DialogActions>
                <Button color='inherit' onClick={onClose} variant='text'>
                  CANCEL
                </Button>

                <LoadingButton loading={isLoading || isSubmitting} type='submit' variant='contained'>
                  SAVE
                </LoadingButton>
              </DialogActions>
            </form>
          )
        }}
      </Formik>
    </Dialog>
  )
}
